import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import HomeView from './home-view';

const HomeContainer = (props) => {
  return (
    <HomeView statistic={props.statistic} />
  );
};

HomeContainer.propTypes = {
  statistic: PropTypes.object,
};
HomeContainer.defaultProps = {
  statistic: null,
};

const mapStateToProps = (state) => ({
  statistic: state.statistic,
});

export default connect(
  mapStateToProps,
  null,
)(HomeContainer);
